"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionAction = exports.planAction = exports.payeePreferred = exports.userAction = exports.shippingPreference = exports.shippingType = void 0;
var shippingType;
(function (shippingType) {
    shippingType["SHIPPING"] = "SHIPPING";
    shippingType["PICKUP_IN_PERSON"] = "PICKUP_IN_PERSON";
})(shippingType || (exports.shippingType = shippingType = {}));
var shippingPreference;
(function (shippingPreference) {
    shippingPreference["GET_FROM_FILE"] = "GET_FROM_FILE";
    shippingPreference["NO_SHIPPING"] = "NO_SHIPPING";
    shippingPreference["SET_PROVIDED_ADDRESS"] = "SET_PROVIDED_ADDRESS";
})(shippingPreference || (exports.shippingPreference = shippingPreference = {}));
var userAction;
(function (userAction) {
    userAction["CONTINUE"] = "CONTINUE";
    userAction["SUBSCRIBE_NOW"] = "SUBSCRIBE_NOW";
})(userAction || (exports.userAction = userAction = {}));
var payeePreferred;
(function (payeePreferred) {
    payeePreferred["UNRESTRICTED"] = "UNRESTRICTED";
    payeePreferred["IMMEDIATE_PAYMENT_REQUIRED"] = "IMMEDIATE_PAYMENT_REQUIRED";
})(payeePreferred || (exports.payeePreferred = payeePreferred = {}));
var planAction;
(function (planAction) {
    planAction["show"] = "";
    planAction["activate"] = "activate";
    planAction["deactivate"] = "deactivate";
})(planAction || (exports.planAction = planAction = {}));
var subscriptionAction;
(function (subscriptionAction) {
    subscriptionAction["show"] = "";
    subscriptionAction["suspend"] = "suspend";
    subscriptionAction["cancel"] = "cancel";
})(subscriptionAction || (exports.subscriptionAction = subscriptionAction = {}));
